import { TOGGLE_THEME } from "../types/themeTypes";

export const toggleTheme = () => ({
  type: TOGGLE_THEME,
});
